export default __webpack_public_path__ + "static/Cover-4727e7683134e47f13a53c2898b2efec.jpg";